import { render, staticRenderFns } from "./PhoneVerification.vue?vue&type=template&id=3c7e77d6&scoped=true&lang=pug&"
import script from "./PhoneVerification.vue?vue&type=script&lang=js&"
export * from "./PhoneVerification.vue?vue&type=script&lang=js&"
import style0 from "./PhoneVerification.vue?vue&type=style&index=0&id=3c7e77d6&prod&lang=css&"
import style1 from "./PhoneVerification.vue?vue&type=style&index=1&id=3c7e77d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7e77d6",
  null
  
)

export default component.exports